import { ButtonUtility } from "@components";
import { Trash01 } from "@untitledui/icons";
import type { InfractionDriverLookupApiResponse } from "../types/infraction-api.types";
import { formatDriverCpfPartial, getDriverInitials } from "../utils/formatters";

type InfractionSelectedDriverCardProps = {
	driver: InfractionDriverLookupApiResponse;
	onRemove: () => void;
	isDisabled?: boolean;
};

export function InfractionSelectedDriverCard({
	driver,
	onRemove,
	isDisabled = false,
}: InfractionSelectedDriverCardProps) {
	const initials = getDriverInitials(driver.name);

	return (
		<div
			className="flex items-center justify-between rounded-lg border border-[rgba(194,198,215,0.2)] bg-[#f8f9fa] p-[17px] shadow-xs"
			data-slot="infraction-selected-driver-card"
		>
			<div className="flex items-center gap-4">
				<div
					aria-hidden
					className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-fg-brand-primary text-fg-white"
				>
					<span className="font-bold text-lg leading-7">{initials}</span>
				</div>
				<div className="flex min-w-0 flex-col">
					<p className="truncate font-bold text-fg-primary text-md">
						{driver.name ?? "Condutor"}
					</p>
					<p className="font-semibold text-fg-secondary text-xs">
						{formatDriverCpfPartial(driver.cpf)}
					</p>
				</div>
			</div>
			<ButtonUtility
				color="tertiary"
				icon={<Trash01 className="size-5 text-fg-brand-primary" />}
				isDisabled={isDisabled}
				onClick={onRemove}
				tooltip="Remover condutor indicado"
			/>
		</div>
	);
}
